export const formatRangeValue = (from: string | number | undefined, to: string | number | undefined, sign: string) => {
  if (from && !to) {
    return `от ${from} ${sign}`;
  }

  if (!from && to) {
    return `до ${to} ${sign}`;
  }

  if (from && to) {
    return `${from} - ${to} ${sign}`;
  }

  return;
};
